export default {
  ACCORDION: "ACCORDION",
  ACCORDION_PANEL: "ACCORDION_PANEL",
  ALONE_CHECKBOX: "ALONE_CHECKBOX",
  ALONE_CHECKBOX_NO_LABEL: "ALONE_CHECKBOX_NO_LABEL",
  ALONE_CHECKBOX_PROCESS_DSFR: "ALONE_CHECKBOX_PROCESS_DSFR",
  ALONE_CHECKBOX_SUMMARY: "ALONE_CHECKBOX_SUMMARY",
  ATTACHMENT: "ATTACHMENT",
  ATTACHMENT_LINK: "ATTACHMENT_LINK",
  ATTACHMENTS: "ATTACHMENTS",
  BUTTON: "BUTTON",
  CARD: "CARD",
  CARD_NEWS: "CARD_NEWS",
  CARDS_LIST: "CARDS_LIST",
  CARDS_LIST_NEWS: "CARDS_LIST_NEWS",
  OLD_CARD_NEWS: "OLD_CARD_NEWS",
  OLD_CARDS_LIST_NEWS: "OLD_CARDS_LIST_NEWS",
  CONTACT_FORM_PROFILE_LIST: "CONTACT_FORM_PROFILE_LIST",
  CONTACT_FORM_PROFILE: "CONTACT_FORM_PROFILE",
  CONTACT_FORM_SUBJECT_LIST: "CONTACT_FORM_SUBJECT_LIST",
  CONTACT_FORM_SUBJECT: "CONTACT_FORM_SUBJECT",
  CALLBACK_REASON_LIST: "CALLBACK_REASON_LIST",
  CALLBACK_REASON: "CALLBACK_REASON",
  CONTENTS_GROUP: "CONTENTS_GROUP",
  CONTENTS_GROUPS_LIST: "CONTENTS_GROUPS_LIST",
  CHECKBOX: "CHECKBOX",
  DATE: "DATE",
  DYNAMIC: "DYNAMIC",
  DSFR_CARD: "DSFR_CARD",
  DSFR_CARDS_SPECIFIC_LIST: "DSFR_CARDS_SPECIFIC_LIST",
  DSFR_CARDS_LIST: "DSFR_CARDS_LIST",
  DSFR_TILE_CARDS_LIST: "DSFR_TILE_CARDS_LIST",
  TILE_CARDS_SPECIFIC_LIST: "TILE_CARDS_SPECIFIC_LIST",
  DSFR_SUBPAGES_LIST: "DSFR_SUBPAGES_LIST",
  DSFR_SUBPAGE: "DSFR_SUBPAGE",
  EDITABLE_INPUT: "EDITABLE_INPUT",
  EXPANSION_PANEL: "EXPANSION_PANEL",
  EXPANSION_PANEL_DETAILS: "EXPANSION_PANEL_DETAILS",
  EXPANSION_TEXT: "EXPANSION_TEXT",
  FILE: "FILE",
  FILE_IMAGE: "FILE_IMAGE",
  GEOLOCALISATION: "GEOLOCALISATION",
  GEOLOC_SOURCETYPE: "GEOLOC_SOURCETYPE",
  GLOSSARY: "GLOSSARY",
  GLOSSARY_ITEM: "GLOSSARY_ITEM",
  GRID: "GRID",
  HIGHLIGHTED_TEXT: "HIGHLIGHTED_TEXT",
  IMAGE: "IMAGE",
  IMAGE_BLOCK: "IMAGE_BLOCK",
  ICON: "ICON",
  ICON_DSFR: "ICON_DSFR",
  ICON_LINK: "ICON_LINK",
  INFO_BLOCK: "INFO_BLOCK",
  INFO_BLOCK_LIST: "INFO_BLOCK_LIST",
  INPUT: "INPUT",
  LINKS_LIST: "LINKS_LIST",
  LINK: "LINK",
  MAILTO: "MAILTO",
  MENU_ITEM: "MENU_ITEM",
  MENU_GROUP: "MENU_GROUP",
  MULTI_SUBPAGES_LIST: "MULTI_SUBPAGES_LIST",
  NUMERIC: "NUMERIC",
  PAGE: "PAGE",
  PICTOGRAM: "PICTOGRAM",
  RADIO_GROUP: "RADIO_GROUP",
  RESULT_LIST: "RESULT_LIST",
  RESULT: "RESULT",
  QUOTE: "QUOTE",
  SELECT: "SELECT",
  SELECT_MULTIPLE: "SELECT_MULTIPLE",
  SHORT_TEXT: "SHORT_TEXT",
  SITE_NAME: "SITE_NAME",
  SLIDER: "SLIDER",
  SLIDER_INLINE: "SLIDER_INLINE",
  STEP: "STEP",
  STEP_V2: "STEP_V2",
  STEP_V2_CONTENT: "STEP_V2_CONTENT",
  TABS_COMPONENT: "TABS_COMPONENT",
  DYNAMIC_TABS: "DYNAMIC_TABS",
  DYNAMIC_TAB: "DYNAMIC_TAB",
  TABS: "TABS",
  TABS_CARDS: "TABS_CARDS",
  TABS_TILE_CARDS: "TABS_TILE_CARDS",
  TAB: "TAB",
  TAB_CARDS: "TAB_CARDS",
  TAB_TILE_CARDS: "TAB_TILE_CARDS",
  TEXT: "TEXT",
  TILE_CARD: "TILE_CARD",
  TILE_CARDS_LIST: "TILE_CARDS_LIST",
  TIMELINE: "TIMELINE",
  SITE_SETTINGS: "SITE_SETTINGS",
  MOURNING_SETTINGS: "MOURNING_SETTINGS",
  SOCIAL_NETWORK: "SOCIAL_NETWORK",
  STEPPER_DSFR: "STEPPER_DSFR",
  STEPPER: "STEPPER",
  STEPPER_STEP_DSFR: "STEPPER_STEP_DSFR",
  STEPPER_STEP: "STEPPER_STEP",
  STEPPER_DETAIL_DSFR: "STEPPER_DETAIL_DSFR",
  STEPPER_DETAIL: "STEPPER_DETAIL",
  SUBPAGES_LIST: "SUBPAGES_LIST",
  SUBPAGE: "SUBPAGE",
  URL: "URL",
  VIDEO: "VIDEO",
  VIDEOS_LIST: "VIDEOS_LIST",
  WARNING_BANNER: "WARNING_BANNER",
  DYNAMIC_LIST: "DYNAMIC_LIST",
  URLS_MAPPING: "URLS_MAPPING",
  ALERT: "ALERT",
  STORE_BUTTONS: "STORE_BUTTONS",
  TEXT_ICON: "TEXT_ICON",
  TABLE: "TABLE",
  TABLE_HEADER: "TABLE_HEADER",
  TABLE_BODY: "TABLE_BODY",
  TABLE_ROW: "TABLE_ROW",
  TABLE_CELL: "TABLE_CELL",
  TABLE_CELL_TEXT: "TABLE_CELL_TEXT",
};
